// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5 3.79H4M5 3.79L5 2M5 3.79H11M11 3.79H12M11 3.79L11 2M12 3.79C13.1 3.79 14 4.69 14 5.79M12 3.79H4M12 3.79C13.1 3.79 14 4.69 14 5.8V6.17C14 6.72 13.55 7.17 13 7.17H3C2.45 7.17 2 6.72 2 6.17V5.8C2 4.69 2.9 3.79 4 3.79M4 3.79C2.9 3.79 2 4.69 2 5.79L2 12C2 13.1 2.9 14 4 14H7.37',
  'M12 10V12M12 12V14M12 12H14M12 12H10',
];
